import './index.scss'
import './meta-key-query'
import './product-query'


wp.blocks.registerBlockStyle( 
  'core/post-template',
  {
    name: 'query-table',
    label: 'Query Table'
  },
);
